// Right Chat - rotas da tela do Kanban proprio.
import RightKanbanView from './RightKanbanView.vue';

const ACCESS = ['administrator', 'agent', 'custom_role'];
const META = { permissions: ACCESS, roles: ACCESS };

export const rightKanbanRoutes = [
  {
    path: '/app/accounts/:accountId/kanban',
    name: 'kanban_view',
    component: RightKanbanView,
    meta: META,
  },
  {
    path: '/app/accounts/:accountId/kanban/boards/:boardId',
    name: 'kanban_board',
    component: RightKanbanView,
    meta: META,
  },
  {
    path: '/app/accounts/:accountId/right-kanban',
    name: 'right_kanban_index',
    component: RightKanbanView,
    meta: META,
  },
  {
    path: '/app/accounts/:accountId/right-kanban/boards/:boardId',
    name: 'right_kanban_board',
    component: RightKanbanView,
    meta: META,
  },
];

export default { routes: rightKanbanRoutes };
